module.exports = __webpack_public_path__ + "img/icon01.4c34d645.png";